<template>
  <nav id="sidebar" class="sidebar-view show uk-animation-slide-left-small">
    <div class="row relative">
      <div class="col-md-12">
        <a href="#" class="logo text-center" name="logo">
          <h4 style="font-weight: 800;font-size: 12px;text-transform: uppercase;color: white;" class="font-weight-bolder">Your🔗Link <span style="color: #CD1919;font-weight: 800;font-size: 12px;text-transform: uppercase;"> HUB</span></h4>
        </a>
      </div>
    </div>
    <ul class="list-unstyled components mb-5">
      <router-link :to="'/bookmark'" tag="li" >
        <a><i class="fas fa-bookmark" style="color: #d17575;"></i> <span class="menu-name">Bookmark</span> </a>
      </router-link>
      <router-link :to="'/passwords'" tag="li" >
        <a><i class="fas fa-key" style="color: #d17575;"></i> <span class="menu-name">Passwords</span> </a>
      </router-link>
      <router-link :to="'/notes'" tag="li" >
        <a><i class="fas fa-sticky-note" style="color: #d17575;"></i> <span class="menu-name">Notes</span> </a>
      </router-link>
      <router-link :to="'/gallery'" tag="li" >
        <a><i class="fas fa-image" style="color: #d17575;"></i> <span class="menu-name">Gallery</span> </a>
      </router-link>

      <router-link :to="'/more'" tag="li" >
        <a><i class="fas fa-info-circle" style="color: #d17575;"></i> <span class="menu-name">More Soon</span> </a>
      </router-link>

      <hr class="mt-2 mb-2" style="border-top: 1px solid #d17575 !important;">

      <router-link :to="'/logout'" tag="li" >
        <a><i class="fas fa-sign-out-alt" style="color: #d17575;"></i> <span class="menu-name">Log Out</span> </a>
      </router-link>
     
     
    </ul>
  </nav>
</template>

<script>

export default {
  data() {
    
    return {
      lists: [
    
      { name: 'Bookmark', icon: 'icon/icon-union.svg', path: '/bookmark' },
      { name: 'Projects', icon: 'icon/icon-company.svg', path: '/projects' },
      { name: 'Notes', icon: 'icon/icon-financial.svg', path: '/notes' },
     
   
      ],
      second_list: [
      { name: 'Images', icon: 'icon/icon-quotation.svg', path: '/gallery' },
      { name: 'Passwords', icon: 'icon/icon-admin.svg', path: '/passwords' },
      ],
    }
  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style>
</style>

<!-- 
<template>
  <nav id="sidebar" class="sidebar-view show uk-animation-slide-left-small">
    <div class="row relative">
      <div class="col-md-12">
        <a href="#" class="logo text-center" name="logo">
          <img src="/assets/img/logo.svg" class="w-100" />
        </a>
      </div>
    </div>
    <ul class="list-unstyled components mb-5">
      <router-link :to="list.path" tag="li" v-for="(list, index) in lists" :key="index">
        <a><img :src="'/assets/img/' + list.icon" class="mr-3"/> <span class="menu-name">{{ list.name }}</span> </a>
      </router-link>
      <hr class="mt-2 mb-2" style="border-top: 1px solid #144566 !important;">
      <router-link :to="list.path" tag="li" v-for="(list, index) in second_list" :key="index">
        <a><img :src="'/assets/img/' + list.icon" class="mr-3"/> <span class="menu-name">{{ list.name }}</span> </a>
      </router-link>
      <hr class="mt-2 mb-2" style="border-top: 1px solid #144566 !important;">
      <router-link :to="list.path" tag="li" v-for="(list, index) in third_list" :key="index">
        <a><img :src="'/assets/img/' + list.icon" class="mr-3"/> <span class="menu-name">{{ list.name }}</span> </a>
      </router-link>
    </ul>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      lists: [
      { name: 'Bookmark', icon: 'icon/icon-union.svg', path: '/bookmark' },
   
      ],
      second_list: [
      { name: 'Dashboard', icon: 'icon/icon-union.svg', path: '/' },
        { name: 'Missions', icon: 'icon/icon-mission.svg', path: '/missions' },
        // { name: 'Quotations', icon: 'icon/icon-quotation.svg', path: '/quotation' },
        // { name: 'Service Providers', icon: 'icon/icon-company.svg', path: '/companies' },
        // { name: 'Customer', icon: 'icon/icon-client.svg', path: '/customer' },
        // { name: 'Admin Users', icon: 'icon/icon-admin.svg', path: '/staff' },
        // { name: 'Finance', icon: 'icon/icon-financial.svg', path: '/finance' },
        // { name: 'Contact Settings', icon: 'icon/icon-contactsetting.svg', path: '/contact-settings' },
        // { name: 'Settings', icon: 'icon/icon-setting.svg', path: '/settings' },
      ],
      third_list: [
      { name: 'Upload', icon: 'icon/icon-union.svg', path: '/upload' },
      { name: 'FirebaseAdd', icon: 'icon/icon-union.svg', path: '/firebaseadd' },
      { name: 'Firebase', icon: 'icon/icon-union.svg', path: '/firebase' },
        { name: 'Bookmarks', icon: 'icon/icon-union.svg', path: '/bookmark' },
        { name: 'Passwords', icon: 'icon/icon-client.svg', path: '/kredenshal' },
        { name: 'projects', icon: 'icon/icon-mission.svg', path: '/projects' },
      ]
    }
  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style>
</style> -->